export function getParsedQueryString(): Record<string, string> {
  const qs = new URLSearchParams(window.location.search);
  return [...qs.entries()].reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value }),
    {},
  );
}
